import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnChanges,
  AfterViewInit,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
} from '@angular/core'
import { DatePipe } from '@angular/common'
import { MatPaginator } from '@angular/material/paginator'
import { MatTable, MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { KeyingStructureService } from '../../../../services/keying.structure.service'
import { take } from 'rxjs'
import { KeySystem, Line, OrderDetails, Structure, Subline } from 'apps/keycom/src/app/models/dev.test.models'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { KeyingSystemService } from 'apps/keycom/src/app/services/keying.system.service'
import { LoadingService } from 'apps/keycom/src/app/services/loading.service'
import { ErrorService } from 'apps/keycom/src/app/services/error.service'

@Component({
    selector: 'app-order-info',
    templateUrl: './order-info.component.html',
    styleUrls: ['./order-info.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class OrderInfoComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() orders: OrderDetails[]
  @Input() structure: Structure
  @Input() keySystem: KeySystem

  displayLineDetails: boolean = true
  sublineDataSource: MatTableDataSource<Subline>

  @ViewChild('orderPagination', { static: false }) orderPaginatior: MatPaginator
  @ViewChildren('sublinePagination') sublinePaginator: QueryList<MatPaginator>

  @ViewChild('outerSort', { static: false }) orderSort: MatSort
  @ViewChildren('innerSort') sublineSort: QueryList<MatSort>

  @ViewChildren('sublineTables') sublineTables: QueryList<MatTable<Subline[]>>

  dataSource: MatTableDataSource<OrderDetails>
  orderDataSource: MatTableDataSource<OrderDetails>
  orderDetailsData: OrderDetails[] = []
  orderDetailData: OrderDetails
  sublines: any[] = []
  parentRowIndex: number = 0
  clickedRowIndex: number = 0

  expandedElement: OrderDetails

  columnsToDisplay: string[] = ['lineDisplay', 'orderNumber', 'orderId', 'status', 'createdOn', 'userName']

  innerDisplayedColumns: string[] = [
    'lineNumber',
    'subLineNumber',
    'groupName',
    'prefix',
    'from',
    'to',
    'suffix',
    'setList',
    'subLineQuantity',
    'keyCombination',
  ]

  sublineHeaderColumns: string[] = ['customerAccountNumber', 'orderId', 'oracleHeaderId']

  orderDetails: OrderDetails

  constructor(
    private keyingStructureService: KeyingStructureService,
    private cd: ChangeDetectorRef,
    private keyingSystemService: KeyingSystemService,
    private errorService: ErrorService,
    private loadingService: LoadingService
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.orders)
    this.dataSource.paginator = this.orderPaginatior
    this.dataSource.sort = this.orderSort
  }

  /* istanbul ignore next */
  ngOnChanges(): void {
    this.dataSource = new MatTableDataSource(this.orders)
    this.dataSource.paginator = this.orderPaginatior
    this.dataSource.sort = this.orderSort
  }

  /* istanbul ignore next */
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.orderPaginatior
    this.dataSource.sort = this.orderSort
  }

  /* istanbul ignore next */
  pageEvents(event: any) {
    this.expandedElement = null

    this.parentRowIndex = event.pageSize * event.pageIndex

    this.dataSource = new MatTableDataSource(this.orders)
    this.dataSource.paginator = this.orderPaginatior
    this.dataSource.sort = this.orderSort
  }

  /* istanbul ignore next */
  toggleRow(element: OrderDetails) {
    this.clickedRowIndex = 0
    this.clickedRowIndex = this.dataSource.filteredData.indexOf(element)
    let sublineindex = this.clickedRowIndex - this.parentRowIndex

    this.sublinePaginator.toArray()[sublineindex].pageSize = 10
    this.sublinePaginator.toArray()[sublineindex].firstPage()

    if (this.expandedElement?.orderId === element.orderId) {
      this.expandedElement = null

      sublineindex = 0
    } else {
      this.loadingService.set({ isLoading: true, message: 'Retrieving Order Details' })
      this.keyingStructureService
        .getOrderSubLineDetails(this.structure.id, this.keySystem.id, element.orderId)
        .pipe(take(1))
        .subscribe((result: OrderDetails) => {
          this.loadingService.set({ isLoading: false, message: '' })

          this.sublineDataSource = new MatTableDataSource(result.sublines)
          this.sublineDataSource.paginator = this.sublinePaginator.toArray()[sublineindex]
          this.sublineDataSource.sort = this.sublineSort.toArray()[sublineindex]
        }),
        (error) => {
          this.loadingService.set({ isLoading: false, message: '' })
          this.errorService.throw(error)
        }
      this.expandedElement = element
    }
  }

  /* istanbul ignore next */
  getOrderSubLIneDetails(structureId: number, keySystemId: number, orderId: number) {
    this.loadingService.set({ isLoading: true, message: 'Getting Order SubLIne Details' })
    this.keyingStructureService
      .getOrderSubLineDetails(structureId, keySystemId, orderId)
      .pipe(take(1))
      .subscribe((result: OrderDetails) => {
        this.loadingService.set({ isLoading: false, message: '' })
      })
  }
}
